import React, { useState } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { Editor } from "react-simple-wysiwyg";
import { EditorProvider } from "react-simple-wysiwyg";
import { toast } from "react-toastify";
import api from "./api";

// 🔥 Slug Generator
const generateSlug = (title) => {
  return title
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-");
};

function AddBlog() {
  const [blog, setBlog] = useState({
    title: "",
    slug: "",
    content: "",
    imageUrl: "",
    isPublished: true,
  });

  const [loading, setLoading] = useState(false);

  // Handle normal inputs
  const handleChange = (e) => {
    setBlog({ ...blog, [e.target.name]: e.target.value });
  };

  // Handle submit
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);

    const res = await api.post("/UiplusBlogs", blog);

    if (res.status === 200 || res.status === 300) {
      toast.success("✅ Blog added successfully");

      setBlog({
        title: "",
        slug: "",
        content: "",
        imageUrl: "",
        isPublished: true,
      });

    } else {
      toast.error("❌ Failed to add blog");
    }

  } catch (error) {
    console.error("API ERROR:", error);
    toast.error("❌ Server error");
  } finally {
    setLoading(false);
  }
};


  return (
    <Container>
      <h3 className="mb-4">Add New Blog</h3>

      <Form onSubmit={handleSubmit}>

        {/* Title */}
        <Form.Group className="mb-3">
          <Form.Label>Blog Title</Form.Label>
          <Form.Control
            type="text"
            value={blog.title}
            placeholder="Enter blog title"
            onChange={(e) => {
              const title = e.target.value;
              setBlog({
                ...blog,
                title: title,
                slug: generateSlug(title),
              });
            }}
            required
          />
        </Form.Group>

        {/* Slug */}
        <Form.Group className="mb-3">
          <Form.Label>Slug</Form.Label>
          <Form.Control value={blog.slug} readOnly />
        </Form.Group>

        <Row>
          {/* Image */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Image URL</Form.Label>
              <Form.Control
                name="imageUrl"
                value={blog.imageUrl}
                placeholder="/images/blog1.jpg"
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          {/* Status */}
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={blog.isPublished}
                onChange={(e) =>
                  setBlog({
                    ...blog,
                    isPublished: e.target.value === "true",
                  })
                }
              >
                <option value={true}>Published</option>
                <option value={false}>Draft</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {/* Editor */}
        <Form.Group className="mb-4">
          <Form.Label>Content</Form.Label>
          <EditorProvider>
          <Editor
            value={blog.content}
            onChange={(e) =>
              setBlog({ ...blog, content: e.target.value })
            }
          />
          </EditorProvider>
        </Form.Group>

        {/* Button */}
        <Button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save Blog"}
        </Button>

      </Form>
    </Container>
  );
}

export default AddBlog;